export default function renderTemplate(path, args = {}) {
  return require(`ejs-compiled-loader!templates/${path}.ejs`)(args);
}
